import { createFeatureSelector, MemoizedSelector } from '@ngrx/store';
import { PRODUCT_FEATURE, ProductState, StateWithProduct } from '../product-state';

export const getCustomProductState: MemoizedSelector<StateWithProduct, ProductState> =
  createFeatureSelector<ProductState>(PRODUCT_FEATURE);
